class Expander {
  constructor(element, options) {
    this._element = element;
    this._options = options;
    this._cacheSelectors();
    this._initTrigger();
    this._initExpander();
  }

  _cacheSelectors() {
    this._trigger = this._element.querySelector('.js-button--expander');
  }

  _initTrigger() {
    this._trigger.addEventListener('click', () => {
      const target = this._element.querySelector('.expander__panel');

      if (target.classList.contains('is-active')) {
        target.closest('.expander').classList.remove('is-active');
        target.classList.remove('is-active');
      } else {
        target.closest('.expander').classList.add('is-active');
        target.classList.add('is-active');
      }
    });
  }

  _initExpander() {
    const target = this._element.querySelector('.expander__panel');

    const defaultOpen = this._options.defaultOpen !== null && this._options.defaultOpen === 'true';

    if (defaultOpen) {
      target.closest('.expander').classList.add('is-active');
      target.classList.add('is-active');
    }
  }
}

export default Expander;
